import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { ModalBody, ModalFooter } from 'reactstrap';
import Modal from '../../../../shared/ui/Modal';
import notesActionCreators from '../../../store/notes/action-creators';
import './NoteList.scss';

class NoteList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDeleteMessage: '',
      isModalOpen: false,
      noteGuid: '',
    };
  }

  // ----------------------
  // Computed
  // ----------------------

  getNotePropertyActions() {
    const editNote = {
      label: 'Edit',
      handlerProp: 'onEdit',
      icon: 'edit',
    };
    const deleteNote = {
      label: 'Delete',
      handlerProp: 'onDelete',
      icon: 'trash',
    };
    return [editNote, deleteNote];
  }

  // ----------------------
  // Methods
  // ----------------------

  deleteNote() {
    this.props.deleteNote(this.state.noteGuid);
    this.setState({
      noteGuid: '',
      confirmDeleteMessage: '',
      isModalOpen: false,
    });
  }

  confirmDeleteNote(note) {
    this.setState({
      noteGuid: note.guid,
      confirmDeleteMessage: `Delete note created "${moment(note.createdDate).format('HH:mm on MMM D, YYYY')}"?`,
      isModalOpen: true,
    });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <div className="notes-list">
          <div className="notes-header">
            <h4>Notes</h4>
            { !this.props.disableEdit && (
              <button
                type="button"
                className="button small primary"
                onClick={() => this.props.onAdd()}>
                <i className="fa fa-plus" />
                <span>Add Note</span>
              </button>
            )}

          </div>
          <div className="notes-list-container">
            {this.props.notes && this.props.notes.length > 0 ? (
              this.props.notes.map((note) => (
                <div className="note" key={note.guid}>
                  { !this.props.disableEdit && (
                    <div>
                      <button
                        type="button"
                        style={{marginRight: '20px'}}
                        className="button small secondary"
                        onClick={() => this.props.editNote(note.guid)}>
                        <i className="fa fa-edit" />
                        <span>Edit Note</span>
                      </button>
                      <button
                        type="button"
                        className="button small secondary"
                        onClick={() => this.confirmDeleteNote(note)}>
                        <i className="fa fa-trash" />
                        <span>Delete Note</span>
                      </button>
                    </div>
                  )}
                  <div className="note-created-by">
                    <b>Created by {note.author.getFullName()} at {moment(note.createdAt).format('HH:mm on MMM D, YYYY')}</b>
                  </div>
                  <div className="note-content" style={{ whiteSpace: 'pre-wrap', unicodeBidi: 'embed' }}>
                    {note.content}
                  </div>
                </div>
              ))
            ) : (
              <div className="alert alert-primary">No notes found</div>
            )}
          </div>
        </div>

        <Modal
          isOpen={this.state.isModalOpen}
          onClose={() => this.setState({ isModalOpen: false })}
          title="Confirm Delete Note"
        >
          <ModalBody>{this.state.confirmDeleteMessage}</ModalBody>
          <ModalFooter>
            <button
              className="button primary"
              onClick={() => this.deleteNote(this.state.deleteIndex)}
            >
              Delete
            </button>
            <button
              className="button"
              onClick={() => this.setState({ isModalOpen: false })}
            >
              Cancel
            </button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapDispatchToProps = (dispatch) => {
  return {
    deleteNote: (noteGuid) => {
      return dispatch(notesActionCreators.deleteNote(noteGuid));
    },
    editNote: (noteGuid) => {
      return dispatch(notesActionCreators.editNote(noteGuid));
    },
  };
};

export default connect(null, mapDispatchToProps)(NoteList);
